import type {
  GetGasMarketMonitoringDailyProdChartParams,
  GetGasMarketMonitoringDailyProdChartResponse,
  GetGasMarketMonitoringFutureProdChartParams,
  GetGasMarketMonitoringFutureProdChartResponse,
  GetGasMarketMonitoringFutureProdDailyParams,
  GetGasMarketMonitoringFutureProdDailyResponse,
  GetGasMarketMonitoringIndicatorsParams,
  GetGasMarketMonitoringIndicatorsResponse,
} from "$/lib/types/api/market-monitoring/gas.types";
import { restApiClient } from "../restApiClient";

export const getGasIndicators = async (
  params: GetGasMarketMonitoringIndicatorsParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas/indicators")
    .query({ ...params })
    .get<GetGasMarketMonitoringIndicatorsResponse>();
};

export const getGasFutureProductsChart = async (
  params: GetGasMarketMonitoringFutureProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas/future-products-chart")
    .query({ ...params })
    .get<GetGasMarketMonitoringFutureProdChartResponse>();
};

export const getGasFutureProductsDailyIndicators = async (
  params: GetGasMarketMonitoringFutureProdDailyParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas/future-products-daily")
    .query({ ...params })
    .get<GetGasMarketMonitoringFutureProdDailyResponse>();
};

export const getGasDailyProductsChart = async (
  params: GetGasMarketMonitoringDailyProdChartParams,
) => {
  return restApiClient
    .url("/market-monitoring/gas/daily-products-chart")
    .query({ ...params })
    .get<GetGasMarketMonitoringDailyProdChartResponse>();
};
